<template>
  <h3>Le tirage compte {{ members.length }} participant{{ members.length > 1 ? "s" : "" }}</h3>
  <ul>
    <li
      v-for="(member, i) in members"
      :key="member.id"
      :class="`member member-${member.name} ${
        player
          ? member.id === player
            ? `player`
            : ``
          : i < 1
          ? `player`
          : ``
      }`"
      @click="drawing === false ? checkedMember(member) : null"
      @dblclick="drawing === false ? editMember(member) : null"
    >
      <button @click="deleteMember(member)" v-if="drawing === false">x</button>

      <div v-if="memberToEdit !== null && memberToEdit.id === member.id">
        <input type="text" v-model="memberToEdit.name" @keypress.enter="save" />

        <select v-model="memberToEdit.av">
          <option>--</option>
          <option v-for="member in members" :key="member.id" :id="member.id">
            {{ member.name }}
          </option>
        </select>
      </div>
      <div class="name" v-else>
        <MemberName :members="members" :id="member.id" />
        &nbsp;
        <AvoidName
          v-if="member.av"
          :members="members"
          :member="member"
        />
      </div>
      <button
        v-if="memberToEdit !== null && memberToEdit.id === member.id"
        @click="save()"
      >
        Save
      </button>
    </li>
  </ul>
  <caption v-if="members.length > 0 && drawing === false">
    If you're not the one in yellow, click on your name;
    <br />
    Doubleclick on a name to change it.
  </caption>
</template>

<script>
import { ref } from "vue";
import AvoidName from "@/components/AvoidName.vue";
import MemberName from "@/components/MemberName.vue";
export default {
  emits: [
    "edit-member",
    "editMember",
    "delete-member",
    "deleteMember",
    "checked-member",
    "checkedMember",
    "draw-members",
    "drawMembers",
    "alert",
  ],
  props: {
    members: {
      type: Array,
      required: true,
    },
    drawing: {
      type: Boolean,
    },
    player: {
      type: String,
      required: true,
    },
  },
  computed: {
    writeWord() {
      let alert = this.alert,
        words = alert.split(" ");

      return words;
    },
  },
  setup(props, { emit }) {
    let memberToEdit = ref(null);

    const deleteMember = (data) => {
      emit("delete-member", data);
    };

    const editMember = (data) => {
      memberToEdit.value = data;
    };

    const save = () => {
      let toEdith = memberToEdit.value;
      if (toEdith.av === "--") toEdith.av = "";
      if (toEdith.name !== toEdith.av) {
        emit("edit-member", memberToEdit.value);
        memberToEdit.value = null;
      }
      if (toEdith.name === toEdith.av) {
        emit("alert", "Un joueur ne peut pas s'exclure lui-même !");
      }
    };

    const checkedMember = (data) => {
      emit("checked-member", data);
    };

    const draw = (data) => {
      emit("draw-members", data);
    };

    return {
      AvoidName,
      MemberName,
      deleteMember,
      memberToEdit,
      editMember,
      checkedMember,
      save,
      draw,
      alert,
    };
  },
};
</script>

<style>
h3 {
  font-size: 1.4rem;
}
ul {
  list-style: none;
  text-align: left;
  padding-inline-start: 0 !important;
  width: 100%;
  margin: 2rem 0;
}
.player {
  background: white;
  border-radius: 2rem;
}
.member {
  position: relative;
  text-align: center;
  margin-bottom: .4rem;
}
.member button {
  position: absolute;
  opacity: 0;
  transition: opacity 0.6s;
  margin: 0;
  margin-right: -1.4rem;
  line-height: 2.5rem;
  text-shadow: 2px 2.5px var(--bg);
  background: none;
}
.member button:first-child {
  left: 0.4rem;
}
.member button:last-child {
  top: 0;
  right: 1.4rem;
}
.member:hover button {
  opacity: 1;
}
</style>